import { LinkOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import cn from "classnames";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import React from "react";

interface Props {
    offerConnection?: {
        offerConnectionCustomFields: { parameter: string; description?: string }[];
    };
    onlyModifiable?: boolean;
    className?: string;
}

export const ConnectionCustomFieldsTooltip: React.FC<Props> = (props: Props) => {
    const { offerConnection } = props;
    const { t } = usePaldockTranslation("ui.connection-custom-fields-tooltip");
    const { t: tOffer } = usePaldockTranslation("offer");

    const customFieldValues: string[] =
        offerConnection?.offerConnectionCustomFields
            .map((customField) => {
                if (!customField.parameter) {
                    return null;
                }

                return customField.parameter + (customField.description ? ` (${customField.description})` : "");
            })
            .filter((customField): customField is string => customField !== null) || [];

    const definedFields = props.onlyModifiable
        ? ["externalId", "redirectUrl", "redirectToken", "price"]
        : ["externalId", "redirectUrl", "redirectToken", "price", "leadId"];

    return (
        <div className={cn("relative")}>
            <div className={cn("absolute", props.className)}>
                <Tooltip
                    title={
                        <span>
                            {t("you_can_use")}:
                            <ul>
                                {definedFields.map((definedField) => (
                                    <li key={definedField}>
                                        {"{" + definedField + "} - " + tOffer("connectionField-" + definedField)}
                                    </li>
                                ))}
                                {customFieldValues.map((customFieldValue) => (
                                    <li key={customFieldValue}>{customFieldValue}</li>
                                ))}
                            </ul>
                        </span>
                    }
                    placement="bottom"
                    trigger="hover"
                >
                    <div className="inline-block relative -left-8 -top-4 z-[100] cursor-pointer">
                        <LinkOutlined />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};
